import { Paper } from '@material-ui/core';
import styled from 'styled-components';

export const Wrapper = styled(Paper)`
  margin-bottom: 1.5rem;

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding-left: 1rem;
  }
`;

export const Label = styled.div`
  padding: 0.5rem 1rem;
`;
